import type { FaireProductEntity } from "../../entity_types/product";

export const p_cmw39watj9: FaireProductEntity = {
  token: "p_cmw39watj9",
  type: "product",
  name: "Scrub Brush | Deshed + Lather",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/5204ac13bce4a3e98fc009007f9d7c69644d71e280c869e4a1f2c8a77340fd1e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58e3007e016c1e8dbee05a7d1d8fd29680589d7aee75f2bf92e4f95d56ff1e0f.jpeg"
  ],
  priceDollars: 9,
  description: "Introduce the Dandylion Scrub Brush into your dog's every day grooming routine to reduce shedding, provide a deeper clean during bath-time and stimulate blood flow to improve skin & coat health. Pairs perfectly with Soothe Shampoo or Fresh Coat.\n\nTwo ways to use:\n\n• Dry to Deshed | Brush through dry fur to help with deshedding. Use daily\n• Wet in Bath | Apply Dandylion’s Soothe Gentle Cleansing Dog Shampoo over wet fur. Lather with Scrub Brush and provide a gentle massage for a foamier lather and a deeper clean.\n\nMade in China",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:39.686Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
